import { render, staticRenderFns } from "./academic_wordgroup_detail.vue?vue&type=template&id=5362cf3e&"
import script from "./academic_wordgroup_detail.vue?vue&type=script&lang=js&"
export * from "./academic_wordgroup_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports